export class BusinessNameGenerator {
  constructor(services, defaultSuggestedComainName = 'www.mystunningwebsite.com') {
    this.services = services;
    this.defaultSuggestedComainName = defaultSuggestedComainName;
  }

  getIconUniqueId(icon) {
    return `${icon.source}${icon.id}`;
  }

  async getAvailableDomainNameFromBusinessName(businessName) {
    let domain = this.defaultSuggestedComainName;
    const { domainCheckerService } = this.services;
    const { suggestions } = await domainCheckerService.getDomainSuggestionsByBusinessName(businessName, { maxResults: 1 });
    if (Array.isArray(suggestions) && suggestions.length > 0) {
      domain = suggestions[0].domain;
    }

    return domain;
  }

  async getDomainAvailability(domain) {
    const { domainCheckerService } = this.services;
    const isParsed = true;
    const availabilityData = await domainCheckerService.checkDomainAvailabilityV2(domain, isParsed);
    return availabilityData;
  }

  async checkIfUserIsLoggedIn() {
    const { userDetailsService } = this.services;
    let userIsLoggedIn = false;
    const { success } = await userDetailsService.getLoggedInUserDetails();
    if (success) {
      userIsLoggedIn = true;
    }
    return userIsLoggedIn;
  }

  getBusinessNames(businessIdea, tags, industry) {
    const { bngApi } = this.services;
    return bngApi.getBusinessNames(businessIdea, tags, industry);
  }

  getDomains(namesList) {
    const { bngApi } = this.services;
    return bngApi.getDomainsNames(namesList);
  }
}
